@if (beingEdited) {
  <form>
    <div class="flex-row align-items-center py-16">
      <div class="flex-grow-1">
        <mat-form-field class="w-50" subscriptSizing="dynamic">
          <mat-label>Template Title</mat-label>
          <input matInput
                 autocomplete="off"
                 type=text
                 name="text"
                 [(ngModel)]="editedTemplate.title">
        </mat-form-field>
      </div>
      <div class="action-buttons">
        <button mat-icon-button
                type="submit"
                (click)="update()"
                [disabled]="!editedTemplate?.title || !editedTemplate?.text"
                [matTooltip]="'Save'">
          <mat-icon>save</mat-icon>
        </button>
        <button mat-icon-button
                (click)="cancel()"
                [matTooltip]="'Cancel'">
          <mat-icon>Cancel</mat-icon>
        </button>
      </div>
    </div>
    <div>
      <mat-form-field class="w-100" subscriptSizing="dynamic">
        <mat-label>Template Text</mat-label>
        <textarea matInput
                  autocomplete="off"
                  [(ngModel)]="editedTemplate.text"
                  name="configuration"
                  cdkTextareaAutosize
        >
			    </textarea>
      </mat-form-field>
    </div>
  </form>
} @else {
  <mat-menu #actionsMenu="matMenu">
    <button mat-menu-item
            (click)="edit()">
      <mat-icon>edit</mat-icon>
      Edit template
    </button>
    <button mat-menu-item
            (click)="templateDeleted.emit()">
      <mat-icon>delete</mat-icon>
      Remove template
    </button>
  </mat-menu>

  <div class="flex-row align-items-center">
    <div class="flex-grow-1">
      <div>{{ template().title }}</div>
      <div class="text-muted">{{ template().text }}</div>
    </div>

    <button mat-icon-button
            [matMenuTriggerFor]="actionsMenu">
      <mat-icon>more_vert</mat-icon>
    </button>
  </div>
}
